import React from "react";
import styled from "@emotion/styled";
import {useSelector} from "react-redux";
import {getSquadById} from "modules/selectors";
import {breakpoints} from "assets/theme";

const Image = styled.img`
	height: 100%;
	max-width: 18px;
	max-height: 18px;
	z-index: 1;
	position: absolute;
	left: 4px;
	top: 3px;

	@media (min-width: ${breakpoints.tablet}) {
		max-width: 30px;
		max-height: 30px;
	}
`;

interface IProps {
	squadId: number;
}

export const SquadLogo: React.FC<IProps> = ({squadId}) => {
	const squad = useSelector(getSquadById)(squadId);
	const image = squad?.image;

	if (!image) {
		return null;
	}

	return <Image className="squad-logo" src={image} alt={squad?.abbreviation} />;
};
